// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"534":"c926b9ba","630":"a8504681","818":"4c21a721"}[chunkId] + ".chunk.css";
};